/**
 * Utility functions for role-based access control and UI rendering
 */

export interface RoleUtilsProps {
  userRoles: string[];
  selectedRole: string;
}

export const createRoleUtils = ({ userRoles, selectedRole }: RoleUtilsProps) => {
  const hasImportAccess = () => {
    return (
      userRoles.includes("HR") ||
      userRoles.includes("ADMIN") ||
      selectedRole === "HR" ||
      selectedRole === "ADMIN"
    );
  };

  const isEmployee = () => {
    return selectedRole === "EMPLOYEE" || 
           (!userRoles.includes("MANAGER") && 
            !userRoles.includes("HR") && 
            !userRoles.includes("ADMIN"));
  };

  const isManager = () => {
    return selectedRole === "MANAGER" || userRoles.includes("MANAGER");
  };

  const isHROrAdmin = () => {
    return selectedRole === "HR" || 
           selectedRole === "ADMIN" || 
           userRoles.includes("HR") || 
           userRoles.includes("ADMIN");
  };

  const getPageTitle = () => {
    if (isHROrAdmin()) {
      return "Attendance Records - Organization View";
    } else if (isManager()) {
      return "Attendance Records - Team View";
    } else {
      return "Attendance Records - My View";
    }
  };

  const getRoleDescription = () => {
    if (isEmployee()) {
      return "View your personal attendance records, track your working hours from last Monday, and monitor your Work From Home days for the current month.";
    } else if (isManager() && !isHROrAdmin()) {
      return "View attendance records for your assigned team members, monitor team statistics, and track overall team performance metrics.";
    } else if (isHROrAdmin()) {
      return "Access organization-wide attendance data, import bulk attendance records via CSV/Excel, and generate comprehensive reports for all employees.";
    }
    return "";
  };

  return {
    hasImportAccess,
    isEmployee,
    isManager,
    isHROrAdmin,
    getPageTitle,
    getRoleDescription,
  };
};

export default createRoleUtils;